import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/web/app/_layout/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppDownloadSection"] */ "/vercel/path0/apps/web/app/[locale]/_app-download/section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/Announcement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/CurrentActivities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/Hero/BaseHero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/LiveThisWeek.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/Partners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/PopUpManager/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/Products.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/Promotions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/(web)/_main-page/sections/UniqueSettlingPoint.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SegmentPage"] */ "/vercel/path0/features/src/misc/segment/segment-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EntryPopup"] */ "/vercel/path0/features/src/shared/entry-popup/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@3.26.4_next@15.5.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__re_6f60c95aa2d12de4b02cd8de65b868ef/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@3.26.4_next@15.5.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__re_6f60c95aa2d12de4b02cd8de65b868ef/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.0_@babel+core@7.28.3_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_5a64d2da76b76471fdacb3f4f700c114/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-facebook.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-instagram.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-linkedin.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-telegram.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-x.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-youtube.svg");
